import axioInstance from "../../custom_utilities/AxiosInstance/axiosInstance";

const instructionApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/testdetails";

const examQuestionApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/exam_single_question";

const examAllQuestionApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/allquestionlist";

const saveAnswerApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/exam_single_save";

const practiceApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/user/practicelist";

const submitExamApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/exam_submit";

const bookmarkApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/saveBookmark";

const examApi = {
  getInstruction: async ({ paperType, paperId }) => {
    const res = await axioInstance.get(
      `${instructionApi}?paper_type=${paperType}&paper_id=${paperId}`
    );
    return res.data;
  },

  getQuestion: async ({ paperType, paperId, qid }) => {
    const res = await axioInstance.get(
      `${examQuestionApi}?paper_type=${paperType}&paper_id=${paperId}&qid=${qid}`
    );
    return res.data;
  },

  getQuestionList: async ({ paperType, paperId }) => {
    const res = await axioInstance.get(
      `${examAllQuestionApi}?paper_type=${paperType}&paper_id=${paperId}`
    );
    return res;
  },

  getPracticeList: async () => {
    const res = await axioInstance.get(practiceApi);
    return res;
  },

  saveAnswer: async (payload) => {
    const res = await axioInstance.post(saveAnswerApi, payload);

    return res.data;
  },

  submitExam: async ({ paperType, paperId, time }) => {
    const res = await axioInstance.post(
      `${submitExamApi}?paper_type=${paperType}&paper_id=${paperId}&time=${time}`
    );
    return res.data;
  },

  saveBookmark: async (payload) => {
    const res = await axioInstance.post(bookmarkApi, payload);
    return res.data;
  },
};

export default examApi;
